// extracted by mini-css-extract-plugin
module.exports = {"feature-lists":"styles_feature-lists__aG62I"};